<template>
  <div class="orderInfo">
    <div class="top">
      <div class="icon"></div>
      <div class="title">订单信息</div>
    </div>
    <div class="line"></div>
    <div class="bottom">
      <div class="colum" v-for="(item, index) in table" :key="index">
        <div class="label">{{ item.label }}</div>
        <div class="value">
          {{
            item.prop == "saleAmount"
              ? returnFloat(tableData[item.prop])
              : tableData[item.prop]
          }}
        </div>
      </div>
      <!-- <div class="column">
        <div class="label">单据编号</div>
        <div class="value">{{ tableData.saleSn }}</div>
      </div>
      <div class="column">
        <div class="label">商家名称</div>
        <div class="value">{{ tableData.shopName }}</div>
      </div>
      <div class="column">
        <div class="label">销售员</div>
        <div class="value">{{ tableData.seller }}</div>
      </div>
      <div class="column">
        <div class="label">联系电话</div>
        <div class="value">{{ tableData.sellerPhone }}</div>
      </div>
      <div class="column">
        <div class="label">货品数量</div>
        <div class="value">{{ tableData.counts }}</div>
      </div>
      <div class="column">
        <div class="label">总售价</div>
        <div class="value">
          {{ tableData.saleAmount | returnFloat(tableData.saleAmount) }}
        </div>
      </div>
      <div class="column">
        <div class="label">顾客姓名</div>
        <div class="value">{{ tableData.customerName }}</div>
      </div>
      <div class="column">
        <div class="label">顾客电话</div>
        <div class="value">{{ tableData.customerPhone }}</div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { returnFloat } from "@/util";
export default {
  props: {
    tableData: {
      type: Object,
      default: () => {},
    },
  },
  filters: { returnFloat },
  data() {
    return {
      table: [
        { label: "单据编号", prop: "saleSn" },
        { label: "商家名称", prop: "shopName" },
        { label: "销售员", prop: "seller" },
        { label: "联系电话", prop: "sellerPhone" },
        { label: "货品数量", prop: "counts" },
        { label: "总售价", prop: "saleAmount" },
        { label: "顾客姓名", prop: "customerName" },
        { label: "顾客电话", prop: "customerPhone" },
      ],
    };
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="less" scoped>
.orderInfo {
  box-sizing: border-box;
  padding: 32px;
  background: #fff;
  width: 100%;
  height: 624px;
  border-radius: 24px;
  .top {
    height: 48px;
    .icon {
      float: left;
      width: 48px;
      height: 48px;
      background: url("../../../assets/order.webp") no-repeat;
      background-size: 100%;
    }
    .title {
      height: 48px;
      line-height: 48px;
      float: left;
      color: rgba(51, 51, 51, 1);
      font-size: 28px;
      font-weight: bold;
      margin-left: 8px;
    }
  }
  .bottom {
    width: 100%;
    height: 464px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .column {
      display: flex;
      justify-content: space-between;
      .label {
        color: rgba(153, 153, 153, 1);
        font-size: 26px;
      }
      .value {
        color: rgba(51, 51, 51, 1);
        font-size: 26px;
      }
    }
  }
}
.line {
  margin: 24px 0;
  width: 100%;
  background: rgba(226, 228, 234, 1);
  height: 2px;
}
</style>
